import React, { useEffect, useState, useRef } from "react";
import {
  DownloadForOffline,
  KeyboardArrowDown,
  KeyboardArrowRight,
} from "@mui/icons-material";
import { tableRowSx, themes, scrollTop } from "services/constants";
import { useSelector } from "react-redux";
import { showToast } from "services/utils/Status";
import { Loader } from "components/Loader";
import { getColorWorkingHours } from "services/utils/Status";
import BSDateRangePicker from "../Status/DateRangePicker";
import * as Mui from "@mui/material";
import sessionHandling from "services/utils/notificationUtils";
import { attendanceStatusHalfBox } from "services/constants/Styles";
import { InfoMessage } from "components/CustomComponents/CustomButton";

const keys = [
  "date",
  "shift",
  "type",
  "status",
  "check_in_time",
  "check_out_time",
  "Leave_credit_hours",
  "break_hours",
  "working_hours",
  "over_time",
  "total_permission_taken",
  "Late_days",
];

export const IndividualWorkingHours = () => {
  const { domain, token, globalSearchValue, userDetails } = useSelector(
    (state) => state.tokenReducer
  );
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(25);
  const [workingHoursDetails, setWorkingHoursDetails] = useState([]);
  const [handleLoading, setHandleLoading] = useState(false);
  const [expandRow, setExpandRow] = useState(null);
  const [userWeeklyReport, setUserWeeklyReport] = useState([]);
  const [masterDataForSearch, setMasterDataForSearch] = useState([]);
  const containerRef = useRef(null);
  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  const handleStartDate = async (startDate, endDate) => {
    let searchStartDate = startDate.split("/").reverse().join("-");
    let searchEndDate = endDate.split("/").reverse().join("-");
    setHandleLoading(true);
    try {
      const response = await fetch(
        `${domain}individual_details_working_hours/?user_id=${userDetails.id}&start_date=${searchStartDate}&end_date=${searchEndDate}`,
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `token ${token}`,
          },
        }
      );
      const res = await response.json();
      if (response.ok) {
        setUserWeeklyReport(res);
        setMasterDataForSearch(res.checkin_details);
        setWorkingHoursDetails(res.checkin_details);
        setHandleLoading(false);
      } else if (response.status === 409) {
        sessionHandling();
      } else {
        throw new Error(res.error);
      }
      setHandleLoading(false);
    } catch (error) {
      showToast("error", error.message);
    }
  };

  const handleTableClick = (date) => {
    setExpandRow(date);
  };

  const DownloadData = () => {
    if (workingHoursDetails.length !== 0) {
      let dataPreparation = [];
      workingHoursDetails?.forEach((element) => {
        let overAllData = {
          date: element.date,
          shift: element.shift,
          overTime: element.over_time,
          checkin: element.check_in_time_formatted,
          checkout: element.check_out_time_formatted,
          break: element.break_hours,
          workingHours: element.working_hours,
          leaveCredit: element.Leave_credit_hours,
          status: element.status,
        };
        dataPreparation = [...dataPreparation, overAllData];
      });
      const username = ["UserName"];
      const WorkingHours = ["WorkingHours"];
      const Permission = ["Permissions"];
      const Late = ["Late"];
      const Break = ["Break"];
      const Leave = ["Leave"];
      const Absent = ["Absent"];
      Permission.push(userWeeklyReport?.total_permission_days);
      Late.push(userWeeklyReport?.total_late_days);
      Leave.push(userWeeklyReport?.personal_leave);
      Break.push(userWeeklyReport?.total_break_hours);
      Absent.push(userWeeklyReport?.absent_days);
      username.push(userDetails?.username);
      WorkingHours.push(userWeeklyReport.weekly_working_hours);
      const items = dataPreparation;
      const TableHead = ["Date"];
      TableHead.push("Shift");
      TableHead.push("Over Time");
      TableHead.push("CheckInTime");
      TableHead.push("CheckOutTime");
      TableHead.push("BreakHours");
      TableHead.push("WorkingHours");
      TableHead.push("LeaveCreditHours");
      TableHead.push("Status");
      const replacer = (key, value) => (value === null ? "" : value);
      const header = Object.keys(items[0]).filter(
        (field) =>
          field !== "break_details" &&
          field !== "permission_details" &&
          field !== "id" &&
          field !== "total_permission_taken" &&
          field !== "total_permission_taken" &&
          field !== "Late_days" &&
          field !== "type"
      );
      let csv = items.map((row) =>
        header
          .map((fieldName) => JSON.stringify(row[fieldName], replacer))
          .join(",")
      );
      csv.unshift(TableHead.join(","));
      csv.unshift(Absent.join(","));
      csv.unshift(Break.join(","));
      csv.unshift(Late.join(","));
      csv.unshift(Leave.join(","));
      csv.unshift(Permission.join(","));
      csv.unshift(WorkingHours.join(","));
      csv.unshift(username.join(","));
      csv = csv.join("\r\n");
      const ConvertData = csv;
      const element = document.createElement("a");
      const file = new Blob([ConvertData], {
        type: "text/plain",
      });
      element.href = URL.createObjectURL(file);
      element.download = "WorkingHours.csv";
      document.body.appendChild(element);
      element.click();
    } else {
      showToast("error", "No data available");
    }
  };

  useEffect(() => {
    const filteredResults = masterDataForSearch.filter((item) =>
      keys.some((key) =>
        item[key]
          ?.toString()
          .toLowerCase()
          .includes(globalSearchValue.toString().toLowerCase())
      )
    );
    setWorkingHoursDetails(filteredResults);
    setPage(0);
  }, [globalSearchValue, masterDataForSearch]);

  useEffect(() => {
    scrollTop(containerRef);
  }, [page]);

  return (
    <React.Fragment>
      <Mui.Grid container>
        <Mui.Grid item xs={9}></Mui.Grid>
        <Mui.Grid item xs={2.7} sx={{ paddingTop: 3 }}>
          <BSDateRangePicker
            handleStartDate={handleStartDate}
            showToday={false}
            triggerDate={true}
          />
        </Mui.Grid>
      </Mui.Grid>
      <>
        <Mui.Grid
          conatiner
          sx={{
            display: "flex",
            flexDirection: "row",
            justifyContent: "space-between",
            margin: 3,
          }}
        >
          <Mui.Box
            sx={{
              boxShadow: 3,
              padding: 3,
              borderRadius: 3,
              backgroundColor: themes.grayColor,
              width: "100%",
            }}
          >
            <Mui.Grid container spacing={1}>
              <Mui.Grid
                item
                xs={1.2}
                sx={{ borderRight: "1.5px solid white", textAlign: "center" }}
              >
                <Mui.Typography>
                  <Mui.Typography
                    sx={{
                      color: themes.whiteColor,
                      fontSize: 20,
                      fontWeight: 800,
                    }}
                  >
                    {userWeeklyReport.working_days
                      ? userWeeklyReport.working_days
                      : 0}
                  </Mui.Typography>
                  <Mui.Typography
                    sx={{
                      color: themes.whiteColor,
                      fontSize: 15,
                      fontWeight: 500,
                    }}
                  >
                    Days
                  </Mui.Typography>
                  <Mui.Typography
                    sx={{
                      color: themes.whiteColor,
                      fontSize: 19,
                      fontWeight: 600,
                    }}
                  >
                    Worked
                  </Mui.Typography>
                </Mui.Typography>
              </Mui.Grid>
              <Mui.Grid
                item
                xs={1.4}
                sx={{ borderRight: "1.5px solid white", textAlign: "center" }}
              >
                <Mui.Typography
                  sx={{
                    color: themes.whiteColor,
                    fontSize: 20,
                    fontWeight: 800,
                  }}
                >
                  {userWeeklyReport.total_late_days
                    ? userWeeklyReport.total_late_days
                    : 0}
                </Mui.Typography>
                <Mui.Typography
                  sx={{
                    color: themes.whiteColor,
                    fontSize: 15,
                    fontWeight: 500,
                  }}
                >
                  Days
                </Mui.Typography>
                <Mui.Typography
                  sx={{
                    color: themes.whiteColor,
                    fontSize: 19,
                    fontWeight: 600,
                  }}
                >
                  Late
                </Mui.Typography>
              </Mui.Grid>
              <Mui.Grid
                item
                xs={1.4}
                sx={{ borderRight: "1.5px solid white", textAlign: "center" }}
              >
                <Mui.Typography
                  sx={{
                    color: themes.whiteColor,
                    fontSize: 20,
                    fontWeight: 800,
                  }}
                >
                  {userWeeklyReport.personal_leave
                    ? userWeeklyReport.personal_leave
                    : 0}
                </Mui.Typography>
                <Mui.Typography
                  sx={{
                    color: themes.whiteColor,
                    fontSize: 15,
                    fontWeight: 500,
                  }}
                >
                  Days
                </Mui.Typography>
                <Mui.Typography
                  sx={{
                    color: themes.whiteColor,
                    fontSize: 19,
                    fontWeight: 600,
                  }}
                >
                  Leave
                </Mui.Typography>
              </Mui.Grid>

              <Mui.Grid
                item
                xs={1.4}
                sx={{ borderRight: "1.5px solid white", textAlign: "center" }}
              >
                <Mui.Typography
                  sx={{
                    color: themes.whiteColor,
                    fontSize: 20,
                    fontWeight: 800,
                  }}
                >
                  {userWeeklyReport.total_break_hours
                    ? userWeeklyReport.total_break_hours
                    : 0}
                </Mui.Typography>
                <Mui.Typography
                  sx={{
                    color: themes.whiteColor,
                    fontSize: 15,
                    fontWeight: 500,
                  }}
                >
                  Hrs
                </Mui.Typography>
                <Mui.Typography
                  sx={{
                    color: themes.whiteColor,
                    fontSize: 19,
                    fontWeight: 600,
                  }}
                >
                  Break
                </Mui.Typography>
              </Mui.Grid>
              <Mui.Grid
                item
                xs={1.4}
                sx={{ borderRight: "1.5px solid white", textAlign: "center" }}
              >
                <Mui.Typography
                  sx={{
                    color: themes.whiteColor,
                    fontSize: 20,
                    fontWeight: 800,
                  }}
                >
                  {userWeeklyReport.absent_days
                    ? userWeeklyReport.absent_days
                    : 0}
                </Mui.Typography>
                <Mui.Typography
                  sx={{
                    color: themes.whiteColor,
                    fontSize: 15,
                    fontWeight: 500,
                  }}
                >
                  Days
                </Mui.Typography>
                <Mui.Typography
                  sx={{
                    color: themes.whiteColor,
                    fontSize: 19,
                    fontWeight: 600,
                  }}
                >
                  Absent
                </Mui.Typography>
              </Mui.Grid>
              <Mui.Grid
                item
                xs={1.4}
                sx={{ borderRight: "1.5px solid white", textAlign: "center" }}
              >
                <Mui.Typography
                  sx={{
                    color: themes.whiteColor,
                    fontSize: 20,
                    fontWeight: 800,
                  }}
                >
                  {userWeeklyReport.total_over_time
                    ? userWeeklyReport.total_over_time
                    : 0}
                </Mui.Typography>
                <Mui.Typography
                  sx={{
                    color: themes.whiteColor,
                    fontSize: 15,
                    fontWeight: 500,
                  }}
                >
                  Hrs
                </Mui.Typography>
                <Mui.Typography
                  sx={{
                    color: themes.whiteColor,
                    fontSize: 19,
                    fontWeight: 600,
                  }}
                >
                  Over Time
                </Mui.Typography>
              </Mui.Grid>

              <Mui.Grid
                item
                xs={1.4}
                sx={{ borderRight: "1.5px solid white", textAlign: "center" }}
              >
                <Mui.Typography
                  sx={{
                    color: themes.whiteColor,
                    fontSize: 20,
                    fontWeight: 800,
                  }}
                >
                  {userWeeklyReport.total_permission_days
                    ? userWeeklyReport.total_permission_days
                    : 0}
                </Mui.Typography>
                <Mui.Typography
                  sx={{
                    color: themes.whiteColor,
                    fontSize: 15,
                    fontWeight: 500,
                  }}
                >
                  Times
                </Mui.Typography>
                <Mui.Typography
                  sx={{
                    color: themes.whiteColor,
                    fontSize: 19,
                    fontWeight: 600,
                  }}
                >
                  Permission
                </Mui.Typography>
              </Mui.Grid>
              <Mui.Grid
                item
                xs={1.4}
                sx={{ borderRight: "1.5px solid white", textAlign: "center" }}
              >
                <Mui.Typography
                  sx={{
                    color: themes.whiteColor,
                    fontSize: 20,
                    fontWeight: 800,
                  }}
                >
                  {userWeeklyReport.weekly_working_hours
                    ? userWeeklyReport.weekly_working_hours
                    : 0}
                </Mui.Typography>
                <Mui.Typography
                  sx={{
                    color: themes.whiteColor,
                    fontSize: 15,
                    fontWeight: 500,
                  }}
                >
                  Hrs
                </Mui.Typography>
                <Mui.Typography
                  sx={{
                    color: themes.whiteColor,
                    fontSize: 19,
                    fontWeight: 600,
                  }}
                >
                  Worked
                </Mui.Typography>
              </Mui.Grid>

              <Mui.Grid item xs={1} sx={{ marginTop: 2 }}>
                &nbsp; &nbsp; &nbsp;&nbsp; &nbsp; &nbsp;
                <Mui.IconButton
                  onClick={() => DownloadData()}
                  sx={{
                    backgroundColor: themes.primary,
                    "&:hover": {
                      backgroundColor: themes.primary,
                    },
                  }}
                >
                  {" "}
                  <DownloadForOffline
                    fontSize="large"
                    sx={{
                      color: themes.blueColor,
                    }}
                  />
                </Mui.IconButton>
              </Mui.Grid>
            </Mui.Grid>
          </Mui.Box>
        </Mui.Grid>

        <Mui.TableContainer
          ref={containerRef}
          sx={{
            marginTop: 2,
            marginLeft: "auto",
            marginRight: "auto",
            maxWidth: "97.5%",
          }}
          className="w-96 border  rounded "
        >
          {" "}
          {handleLoading ? (
            <Loader info="Loading..." />
          ) : (
            <Mui.Table className="border">
              <Mui.TableHead
                sx={{
                  backgroundColor: themes.primary,
                  position: "sticky",
                  top: -1,
                  zIndex: 10,
                }}
              >
                <Mui.TableRow sx={tableRowSx}>
                  <Mui.TableCell>
                    <Mui.Typography fontWeight={"bold"}></Mui.Typography>
                  </Mui.TableCell>
                  <Mui.TableCell>
                    <Mui.Typography fontWeight={"bold"}>Date</Mui.Typography>
                  </Mui.TableCell>
                  <Mui.TableCell>
                    <Mui.Typography fontWeight={"bold"}>Shift</Mui.Typography>
                  </Mui.TableCell>
                  <Mui.TableCell>
                    <Mui.Typography fontWeight={"bold"}>
                      Check-In
                    </Mui.Typography>
                  </Mui.TableCell>
                  <Mui.TableCell>
                    <Mui.Typography fontWeight={"bold"}>
                      Check-Out
                    </Mui.Typography>
                  </Mui.TableCell>
                  <Mui.TableCell>
                    <Mui.Typography fontWeight={"bold"}>Break</Mui.Typography>
                  </Mui.TableCell>
                  <Mui.TableCell>
                    <Mui.Typography fontWeight={"bold"}>
                      Over Time
                    </Mui.Typography>
                  </Mui.TableCell>
                  <Mui.TableCell>
                    <Mui.Typography fontWeight={"bold"}>
                      Working Hours
                    </Mui.Typography>
                  </Mui.TableCell>
                  <Mui.TableCell>
                    <Mui.Typography fontWeight={"bold"}>
                      Leave Credit Hours
                    </Mui.Typography>
                  </Mui.TableCell>
                  <Mui.TableCell>
                    <Mui.Typography fontWeight={"bold"}>Status</Mui.Typography>
                  </Mui.TableCell>
                </Mui.TableRow>
              </Mui.TableHead>
              <Mui.TableBody>
                {workingHoursDetails?.length === 0 ? (
                  <InfoMessage dataLength={masterDataForSearch} />
                ) : (
                  workingHoursDetails
                    ?.slice(
                      page * rowsPerPage,
                      page * rowsPerPage + rowsPerPage
                    )
                    .map((user) => (
                      <>
                        <Mui.TableRow sx={tableRowSx}>
                          <Mui.TableCell>
                            {expandRow === user.date ? (
                              <Mui.IconButton
                                onClick={() => handleTableClick(null)}
                              >
                                <KeyboardArrowDown />
                              </Mui.IconButton>
                            ) : user.status === "A" || user.status === "L" ? (
                              ""
                            ) : (
                              <Mui.IconButton
                                onClick={() => handleTableClick(user.date)}
                              >
                                <KeyboardArrowRight />
                              </Mui.IconButton>
                            )}
                          </Mui.TableCell>
                          <Mui.TableCell>{user.date}</Mui.TableCell>
                          <Mui.TableCell>{user.shift}</Mui.TableCell>
                          <Mui.TableCell>
                            {user.check_in_time_formatted}
                          </Mui.TableCell>
                          <Mui.TableCell>
                            {user.check_out_time_formatted}
                          </Mui.TableCell>
                          <Mui.TableCell>
                            {user.status === "A" ||
                            user.status === "L" ||
                            user.status === "W" ? null : (
                              <Mui.Typography>
                                {user.break_hours === "" ||
                                user.break_hours === "00:00"
                                  ? "00:00"
                                  : user.break_hours}
                              </Mui.Typography>
                            )}
                          </Mui.TableCell>
                          <Mui.TableCell>
                            {user.status === "A" ||
                            user.status === "L" ||
                            user.status === "W" ? null : (
                              <Mui.Typography>{user.over_time}</Mui.Typography>
                            )}
                          </Mui.TableCell>
                          <Mui.TableCell>
                            {user.status === "A" ||
                            user.status === "L" ||
                            user.status === "W" ? null : (
                              <Mui.Typography>
                                {user.working_hours === "" ||
                                user.working_hours === "00:00"
                                  ? "00:00"
                                  : user.working_hours}
                              </Mui.Typography>
                            )}
                          </Mui.TableCell>
                          <Mui.TableCell>
                            {user.status === "L" ||
                            user.status === "H" ||
                            user.status === "LA" ||
                            user.status === "AL" ||
                            user.status === "LP" ||
                            user.status === "PL" ? (
                              <Mui.Typography>
                                {user.Leave_credit_hours}
                              </Mui.Typography>
                            ) : null}
                          </Mui.TableCell>
                          <Mui.TableCell>
                            <Mui.Typography
                              sx={{
                                display: "inline-block",
                                width: "28px",

                                color:
                                  user.status === "W"
                                    ? themes?.headLine
                                    : themes.whiteColor,
                                border:
                                  user.status === "W"
                                    ? "1px solid black"
                                    : "none",
                                height: "28px",
                                textAlign: "center",
                                lineHeight: "29px",
                                backgroundColor: getColorWorkingHours(
                                  user.status
                                ),
                              }}
                            >
                              {user.status === "HL" ||
                              user.status === "PL" ||
                              user.status === "LP" ||
                              user.status === "AL" ||
                              user.status === "LA" ? (
                                <Mui.Grid container>
                                  {user.status === "HL" && (
                                    <>
                                      <Mui.Typography
                                        sx={{
                                          ...attendanceStatusHalfBox,
                                          backgroundColor:
                                            user.half_day_leave_period === "2nd"
                                              ? themes.greenColor
                                              : themes.yellowColor,
                                        }}
                                      >
                                        H
                                      </Mui.Typography>
                                      <Mui.Typography
                                        sx={{
                                          ...attendanceStatusHalfBox,
                                          backgroundColor:
                                            user.half_day_leave_period === "2nd"
                                              ? themes.yellowColor
                                              : themes.greenColor,
                                        }}
                                      >
                                        L
                                      </Mui.Typography>
                                    </>
                                  )}
                                  {user.status === "PL" && (
                                    <>
                                      <Mui.Typography
                                        sx={{
                                          ...attendanceStatusHalfBox,
                                          backgroundColor: themes.greenColor,
                                        }}
                                      >
                                        P
                                      </Mui.Typography>
                                      <Mui.Typography
                                        sx={{
                                          ...attendanceStatusHalfBox,
                                          backgroundColor: themes.yellowColor,
                                        }}
                                      >
                                        L
                                      </Mui.Typography>
                                    </>
                                  )}
                                  {user.status === "LP" && (
                                    <>
                                      <Mui.Typography
                                        sx={{
                                          ...attendanceStatusHalfBox,
                                          backgroundColor: themes.yellowColor,
                                        }}
                                      >
                                        L
                                      </Mui.Typography>
                                      <Mui.Typography
                                        sx={{
                                          ...attendanceStatusHalfBox,
                                          backgroundColor: themes.greenColor,
                                        }}
                                      >
                                        P
                                      </Mui.Typography>
                                    </>
                                  )}
                                  {user.status === "AL" && (
                                    <>
                                      <Mui.Typography
                                        sx={{
                                          ...attendanceStatusHalfBox,
                                          backgroundColor: themes.redColor,
                                        }}
                                      >
                                        A
                                      </Mui.Typography>
                                      <Mui.Typography
                                        sx={{
                                          ...attendanceStatusHalfBox,
                                          backgroundColor: themes.yellowColor,
                                        }}
                                      >
                                        L
                                      </Mui.Typography>
                                    </>
                                  )}
                                  {user.status === "LA" && (
                                    <>
                                      <Mui.Typography
                                        sx={{
                                          ...attendanceStatusHalfBox,
                                          backgroundColor: themes.yellowColor,
                                        }}
                                      >
                                        L
                                      </Mui.Typography>
                                      <Mui.Typography
                                        sx={{
                                          ...attendanceStatusHalfBox,
                                          backgroundColor: themes.redColor,
                                        }}
                                      >
                                        A
                                      </Mui.Typography>
                                    </>
                                  )}
                                </Mui.Grid>
                              ) : (
                                user.status
                              )}
                            </Mui.Typography>
                          </Mui.TableCell>
                        </Mui.TableRow>
                        {expandRow === user.date && (
                          <Mui.TableRow sx={tableRowSx}>
                            <Mui.TableCell colSpan={10}>
                              <Mui.TableContainer
                                sx={{
                                  width: "100%",
                                  marginTop: 0,
                                  marginLeft: "auto",
                                  marginRight: "auto",
                                }}
                                className="w-96 border rounded"
                              >
                                {user.break_details.length !== 0 ? (
                                  <Mui.Table className="border">
                                    <Mui.TableHead
                                      sx={{
                                        backgroundColor: themes.primary,
                                      }}
                                    >
                                      <Mui.TableRow sx={tableRowSx}>
                                        <Mui.TableCell></Mui.TableCell>
                                        <Mui.TableCell></Mui.TableCell>
                                        <Mui.TableCell>
                                          <Mui.Typography fontWeight={"bold"}>
                                            Break Start
                                          </Mui.Typography>
                                        </Mui.TableCell>
                                        <Mui.TableCell>
                                          <Mui.Typography fontWeight={"bold"}>
                                            Break End
                                          </Mui.Typography>
                                        </Mui.TableCell>
                                        <Mui.TableCell>
                                          <Mui.Typography fontWeight={"bold"}>
                                            Overall Break Time
                                          </Mui.Typography>
                                        </Mui.TableCell>
                                      </Mui.TableRow>
                                    </Mui.TableHead>
                                    <Mui.TableBody>
                                      {user.break_details.map(
                                        (breakDetail, index) => (
                                          <Mui.TableRow
                                            key={index}
                                            sx={tableRowSx}
                                          >
                                            <Mui.TableCell></Mui.TableCell>
                                            <Mui.TableCell></Mui.TableCell>
                                            <Mui.TableCell>
                                              {breakDetail.break_out}
                                            </Mui.TableCell>
                                            <Mui.TableCell>
                                              {breakDetail.break_in}
                                            </Mui.TableCell>
                                            <Mui.TableCell>
                                              {
                                                breakDetail.individual_break_time
                                              }
                                            </Mui.TableCell>
                                          </Mui.TableRow>
                                        )
                                      )}
                                    </Mui.TableBody>
                                  </Mui.Table>
                                ) : (
                                  <Mui.Stack sx={{ padding: 0.5 }} fullWidth>
                                    <Mui.Alert severity="info">
                                      There is a no available breaks
                                    </Mui.Alert>
                                  </Mui.Stack>
                                )}
                              </Mui.TableContainer>
                            </Mui.TableCell>
                          </Mui.TableRow>
                        )}
                      </>
                    ))
                )}
              </Mui.TableBody>
              {workingHoursDetails?.length === 0 ? null : (
                <Mui.TableBody>
                  <Mui.TableRow sx={tableRowSx}>
                    <Mui.TableCell></Mui.TableCell>
                    <Mui.TableCell></Mui.TableCell>
                    <Mui.TableCell></Mui.TableCell>
                    <Mui.TableCell></Mui.TableCell>
                    <Mui.TableCell></Mui.TableCell>
                    <Mui.TableCell>
                      <Mui.Typography>Total</Mui.Typography>
                    </Mui.TableCell>
                    <Mui.TableCell>
                      {" "}
                      {userWeeklyReport.total_over_time}
                    </Mui.TableCell>
                    <Mui.TableCell>
                      {userWeeklyReport.total_working_hours}
                    </Mui.TableCell>
                    <Mui.TableCell>
                      {" "}
                      {userWeeklyReport.total_leave_credit_hours}
                    </Mui.TableCell>
                    <Mui.TableCell></Mui.TableCell>
                  </Mui.TableRow>
                </Mui.TableBody>
              )}
            </Mui.Table>
          )}
        </Mui.TableContainer>
        <br></br>
        {workingHoursDetails?.length > 25 && (
          <Mui.TablePagination
            sx={{ marginRight: 5 }}
            className="custom-pagination"
            rowsPerPageOptions={[25, 50, 75, 100]}
            component="div"
            count={workingHoursDetails?.length}
            page={page}
            onPageChange={handleChangePage}
            rowsPerPage={rowsPerPage}
            onRowsPerPageChange={handleChangeRowsPerPage}
          />
        )}
      </>
    </React.Fragment>
  );
};
